import { z } from 'zod';
import { defineEndpoint } from '../define';

/** Presigned download URL of one attempt's archived full-logs zip. */
export const getWorkflowRunLogs = defineEndpoint({
  method: 'GET',
  path: '/v1/releases/:releaseId/runs/:runId/attempts/:attemptNumber/logs',
  params: z.object({
    releaseId: z.string().uuid(),
    runId: z.string().uuid(),
    attemptNumber: z.coerce.number().int().min(1),
  }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({ data: z.object({ url: z.string() }) }),
});
